import { supabase } from '@/lib/supabase';

export type ManagePartnerInvitationInput = {
  invitationToken: string;
  status: 'accepted' | 'declined';
};

export const managePartnerInvitation = async ({
  invitationToken,
  status,
}: ManagePartnerInvitationInput) => {
  const { data, error } = await supabase
    .from('contractor_subproject_invitation')
    .update({ status })
    .eq('invitation_token', invitationToken)
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data;
};
